export function recordDate(now: number, timeZone = 'Europe/Stockholm'): string {
  return new Intl.DateTimeFormat('sv-SE', { timeZone }).format(new Date(now))
}
